import React, { CSSProperties } from "react";
import Icon from "../icon";

interface QuantitySelectorProps {
  min: number;
  max: number;
  quantity: number;
  borderColor?: string;
  textColor?: string;
  disabledOpacity?: "opacity-0" | "opacity-50" | "opacity-100";
  onPlusClick: () => void,
  onMinusClick: () => void
}

export default class QuantitySelector extends React.Component<QuantitySelectorProps> {
  static defaultProps = {
    min: 0,
    max: 10,
  }

  get style(){
    return {
      '--border-color': this.props.borderColor || "#EAEAF2",
      '--text-color': this.props.textColor || "black",
    } as CSSProperties
  }

  render() {
    const min = this.props.min;
    const max = this.props.max;
    const isMinusDisabled = this.props.quantity <= min;
    const isPlusDisabled = this.props.quantity >= max;
    const buttonStyles = `w-8 h-8 flex justify-center items-center rounded-full border-2 border-[color:var(--border-color)] text-[color:var(--text-color)]`;
    const disabledOpacity = this.props.disabledOpacity || "opacity-0";

    return (
    <div className="flex flex-row items-center gap-2" style={this.style}>
      <button
        className={[buttonStyles, isMinusDisabled ? disabledOpacity : ""].join(" ")}
        disabled={isMinusDisabled}
        onClick={this.props.onMinusClick}
      >
        <Icon icon="Minor" className="h-6 w-6" />
      </button>
      <span className="text-base font-semibold w-5 text-center text-[color:var(--text-color)]">{this.props.quantity}</span>
      <button
        className={[buttonStyles, isPlusDisabled ? disabledOpacity : ""].join(" ")}
        disabled={isPlusDisabled}
        onClick={this.props.onPlusClick}
      >
        <Icon icon="Plus" className="h-6 w-6" />
      </button>
    </div>
   );
  }}
